import { Elastic, TweenLite, TweenMax } from "gsap";
import * as PIXI from 'pixi.js';
import { CreateElement, Point, Rect, Scale, Size, TranslateScreen1To1 } from "../../.././MyHelpers";
import { Track } from "../../../AudioManager";
import { FontResource } from "../../../ResourceManager/FontResource";
import { ImageResource } from "../../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { Settings } from "../../../Settings";
import { ZIndex } from "../../../ZIndex";
import { JackpotLevel, ScatterRandomAwardResult, SpinAndHoldCommonConfiguration } from "../../../api";
import { service } from "../../../services";
import { SlotGameType1Shared } from "../../../slot/SlotGameType1Shared";
import { BigWinCountAnimation } from "../../BigWinCountAnimation";
import { CanvasSprite } from "../../Sprite/CanvasSprite";
import { SpinAndHoldBonus } from "./SpinAndHold";
import { SpinAndHoldBonusFactory } from "./SpinAndHoldFactory";
import { SpinAndHoldParams } from "./SpinAndHoldParams";
import { SpinAndHoldState } from "./SpinAndHoldState";


export class SpinAndHoldBonus_1Screen extends SpinAndHoldBonus {

	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		this.reelSpinAnimations.forEach(animation => {
			animation.UpdateSpinSpeed(changeSpeedParams.SpinParams)
		});
		// this.commetView.UpdateCometAnimation(changeSpeedParams.CelebrationFactor)
	}
	//protected transitionView: HTMLElement = null;

	public override CreateTransitionPixi(app? : PIXI.Container): void {
		//throw new Error("Method not implemented.");
		// this.transitionView.CreateTransitionPixi(app);
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		this.transitionView.DestroyTransitionPixi();
	}

	protected PathGame: string = null;
	protected winStats: HTMLElement = null;
	protected win: HTMLElement = null;
	protected totalwin: HTMLElement = null;
	protected freegameStats: HTMLElement = null;
	protected left: HTMLElement = null;
	protected freegameLeftNum: HTMLElement = null;
	protected ContainerSprite: CanvasSprite = null;
	protected WinValueSprite: CanvasSprite = null;
	protected bigWinCountAnimation: BigWinCountAnimation = null;
	protected bigWinCountAnimationRemmaining: BigWinCountAnimation = null;
	protected WinContainer: HTMLElement = null;
	protected FrameSprite: CanvasSprite = null;
	protected WinCountAnimation: BigWinCountAnimation = null;
	protected StickyBonusSprite: CanvasSprite = null;
	protected WinCanvasShow: HTMLCanvasElement = null;
	protected ctxWinCanvasShow: CanvasRenderingContext2D = null;


	//Background Transition;
	public containerBackgroundShowWin : HTMLElement = null;
	//public backgroundJpShowWin : HTMLElement [] = [];


	
	
	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
		this.PathGame = Settings.ResourcesFolder + "multigame/slot/" + gameName + "/resources/"
	}



	protected override async BasePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await super.BasePrepare(resourceManager);
		//resourceManager.Add(new ImageResource(this.PathGame + "BackgroundTransition_1Screen.png", this.resid.ScopedResourceName(["BackgroundTransition", "image"])));
		resourceManager.AddGlobal(new SpriteResource(this.params.gameBonusResourcesBasePath + "ValueContainer", ResourceIdentifier.Global.Add("HoldAndSpin").Add(this.gameName + "ValueContainer"), true, this.logGroup.Add(this.gameName), true));
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/TextContainer", ResourceIdentifier.Global.Add("HoldAndSpin").Add("TextContainer"), true, this.logGroup.Add("TextContainer"), true));
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/frameSprite", this.resid.Add("frameSprite"), true, this.logGroup.Add("frameSprite"), true));
		resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/BonusTitle", ResourceIdentifier.Global.Add("StickyBonus").Add("BonusTitleStickyBonus"), true, this.logGroup.Add("freegame"), true));

		Object.keys(JackpotLevel).forEach(jp => {
			let path = this.params.commonBonusResourcesBasePath + `resources/BackgroundShow/${JackpotDisplayProperties[Settings.JackpotDisplayType].alias ?? Settings.JackpotDisplayType}/${JackpotLevel[jp]}Background.png`+ this.resid.ScopedResourceName(["background", JackpotLevel[jp]]);
			resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + `resources/BackgroundShow/${JackpotDisplayProperties[Settings.JackpotDisplayType].alias ?? Settings.JackpotDisplayType}/${JackpotLevel[jp]}Background.png`, this.resid.ScopedResourceName(["background", JackpotLevel[jp]])));
			console.log('BackgroundShowPath:', path);
		});
	}

	protected override async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		{
			await this.scatterRandomAwardFeature.ResourcesLoaded(resourceManager);
		}

		{
			await this.holdingFeature.ResourcesLodaded(resourceManager, this.scatterRandomAwardFeature.GetAwardOptions());
			this.view.appendChild(this.holdingFeature.View());
			this.holdingFeature.View().style.display = "none";
		}
	}

	protected override async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/coin.png", this.resid.ScopedResourceName(["plusone", "image"])));
		
		{
			let params: ScatterRandomAwardParams = 
			{
				logGroup: this.logGroup,
				resid: this.resid,
				reelSet: this.config.ReelSet.map(rs => rs.Symbols),
				availableSymbols: this.params.symbols,
			};

			let config: ScatterRandomAwardConfiguration = this.config.FeatureConfiguration.find(f => f && f.FeatureType == "ScatterRandomAward") as ScatterRandomAwardConfiguration;

			this.scatterRandomAwardFeature = new ScatterRandomAwardPIXI(params, config, this.params.color);
			await this.scatterRandomAwardFeature.PrepareResources(resourceManager);
			config = null;
			params = null;
		}

		{
			// let params: HoldingFeatureParamsPIXI = 
			// {
			// 	logGroup: this.logGroup,
			// 	resid: this.resid,
			// 	spinnableReels: this.spinnableReels2,
			// 	gameResourcesBasePath: this.params.gameBonusResourcesBasePath,
			// 	reelsCoverAnotherScreen : false

			// };

			// this.holdingFeature = new HoldingFeaturePIXIApp(params);
			// await this.holdingFeature.PrepareResources(resourceManager);
			// params = null;
			await this.HoldingFeaturePrepare(resourceManager)
		}
	}

	protected override async PrepareFonts(resourceManager: IWriteOnlyResourceManager): Promise<void> 
	{	
		await super.PrepareFonts(resourceManager);
		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "fontStyle.ttf", this.resid.ScopedResourceName("font")));
	}



	protected override async BaseLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		//super.BaseLoaded(resourceManager);
		this.FreeGameStats();
		await this.SpriteContainer(resourceManager);
		this.BigCountAnimation(resourceManager);
		this.BigCountAnimationRemaining(resourceManager);
		this.SpriteWinFrameLoaded(resourceManager);
		this.CanvaswinCountShow(resourceManager);
		this.totalwin.appendChild(this.translator.Anchor(() => this.translator.t.totalwinHoldAndSpin));
		this.left.appendChild(this.translator.Anchor(() => this.translator.t.totalleftHoldAndSpin));
		this.CreateBackgroundJpShow(resourceManager)
	}

	protected jackpotBackground: Map<JackpotLevel, HTMLElement> = new Map<JackpotLevel, HTMLElement>();
	protected CreateBackgroundJpShow(resourceManager: IReadOnlyResourceManager)
	{


		this.containerBackgroundShowWin = CreateElement("div", {
			classes: ["containerBackgroundShowWin"],
			parentToAppend: this.view,
			style: {
				justifyContent: "center",
				display: "block",
				position: "absolute",
				width : Scale.Wpx(1920),
				height : Scale.Hpx(1080),
				zIndex: ZIndex.JPWinVideo + "",
				top : "0px",				
			}
		});


		Object.keys(JackpotLevel).forEach(jp => {

			let backgroundElement = CreateElement("div", {
				classes: [`background-${JackpotLevel[jp]}`],
				parentToAppend: this.containerBackgroundShowWin,
				style: {
					justifyContent: "center",
					display: "none",
					position: "absolute",
					width : Scale.Wpx(1920),
					height : Scale.Hpx(1080),
					background: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", JackpotLevel[jp]])).CssBackground(),
					backgroundSize : "contain",
					backgroundRepeat : "no-repeat",					
				}
			});

			this.jackpotBackground.set(JackpotLevel[jp],backgroundElement);
		});

		
	}

	protected async SpriteContainer(resourceManager: IReadOnlyResourceManager) {
		this.WinValueSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("HoldAndSpin").Add(this.gameName + "ValueContainer")).sprite, canvasSize: new Size(Scale.W(250), Scale.H(250))});
		this.WinValueSprite.View().style.display = "block";
		this.WinValueSprite.Scale(1.1);
		//this.WinValueSprite.View().style.position = "relative";
		//this.WinValueSprite.View().style.left = Scale.Xpx(-68);
		//this.WinValueSprite.View().style.top = Scale.Ypx(-51);
		//this.WinValueSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));

		this.WinValueSprite.Start(true);
		this.winStats.appendChild(this.WinValueSprite.View());

		this.ContainerSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("HoldAndSpin").Add("TextContainer")).sprite, canvasSize: new Size(Scale.W(500), Scale.H(170))});
		this.ContainerSprite.View().style.display = "vissible";
		this.ContainerSprite.ScaleNonUniform(1.5, 1.2);
		//this.ContainerSprite.View().style.position="absolute";
		//this.ContainerSprite.View().style.left = Scale.Xpx(486);
		this.ContainerSprite.Start(true);


		this.freegameLeftNum.appendChild(this.ContainerSprite.View());
		//Stats.appendChild(this.ContainerSprite.View());


	}

	protected override DesinationComet(): Point {
		//let destination: Point = TranslateScreen2To1(new PixelRect(0, 0, 1920, 1080)).Center();
		let destination: Point = TranslateScreen1To1(new Rect(Scale.X(-265), Scale.Y(-420), Scale.W(1920), Scale.H(1080))).Center();

		return destination
	}
	// //LOAD TITLE FOR TRANSITION 
	// public LoadTitleTransition(resourceManager: ResourceManager) {
	// 	super.LoadTitleTransition(resourceManager);

	// 	// this.TitleSpriteTransition.View().style.top = Scale.Ypx(0);

	// 	// this.transitionView = document.createElement("div");
	// 	// this.transitionView.classList.add("TransitionSpinAndHold");
	// 	// this.transitionView.style.height = Scale.Hpx(1080);
	// 	// this.transitionView.style.width = Scale.Wpx(1920);
	// 	// //this.transitionView.style.background="black";
	// 	// this.transitionView.style.display = "none";
	// 	// this.transitionView.style.position = "absolute";
	// 	// this.transitionView.style.top = Scale.Ypx(0);

	// 	// this.transitionView.style.zIndex = ZIndex.BonusTransition.toString();
	// 	// this.transitionView.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["BackgroundTransition", "image"])).CssBackground(),
	// 	// 	//this.transitionView.appendChild(this.TitleSpriteTransition.View());
	// 	// this.transitionView.style.backgroundSize = "contain";
	// 	// this.view.appendChild(this.transitionView);


	// }

	protected FreeGameStats() {
		this.freegameStats = CreateElement("div", {
			classes: ["freegame-stats"],
			parentToAppend: this.view,
			style: {
				justifyContent: "center",
				display: "contents",
				position: "absolute",
				zIndex: ZIndex.HoldAndStopBonusStats.toString(),
				
				
			}
		});

		this.freegameLeftNum = CreateElement("div", {
			classes: ["freegames-left", "freegames-num"],
			parentToAppend: this.freegameStats,
			style: {
				width: (Scale.W(1920) / 3) + "px",
				display: "flex",
				flexDirection: "row",
				boxSizing: "border-box",
				position: "absolute",
				left: Scale.Xpx(80),
				top: Scale.Ypx(-75),
				zIndex: ZIndex.HoldAndStopBonusStats.toString(),
				justifyContent : "center",
				alignContent : "center",
				
			}
		});

		this.left = CreateElement("div", {
			classes: ["freegames-num-title"],
			id: "left",
			parentToAppend: this.freegameLeftNum,
			style: {

				//border: 1px solid green;
				boxSizing: "border-box",

				fontSize: `${Scale.XYpx(45)}`,
				fontFamily: this.resid.ScopedResourceName("font"),
				textShadow: `0px ${Scale.XYpx(10)} ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(20)} black`,
				color: "yellow",
				textAlign: "center",
				alignItems: "center",
				alignSelf: "center",
				margin: Scale.XYpx(8),
				position: "absolute",
				//left: Scale.Xpx(151),
				top: Scale.Ypx(20),
				lineHeight: Scale.fhpx(70),
				display: "block",
				
				
			}
		});

		this.winStats = CreateElement("div", {
			classes: ["win-stats"],
			parentToAppend: this.freegameStats,
			style: { 
						//width: Scale.Wpx(170),
					 	//height: Scale.Hpx(170),
						position: "absolute",
						left: Scale.Xpx(621.25),
						top: Scale.Ypx(-225),
					}
		});

		this.win = CreateElement("div", {
			classes: ["win"],
			parentToAppend: this.winStats,
			style: {
				width: Scale.Wpx(244),
				height: Scale.Hpx(110),
				position: "relative",
				left: Scale.Xpx(4),
				top: Scale.Ypx(186),
			}

		});

		
	}

	protected BigCountAnimation(resourceManager: IReadOnlyResourceManager) {
		this.bigWinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(80), Scale.H(80)), Scale.fh(55), this.resid.ScopedResourceName("bigwincount"));
		let countView = this.bigWinCountAnimation.View();
		countView.style.position = "relative";
		countView.style.display = "block";
		countView.style.alignContent = "center";
		countView.style.justifyContent = "center";
		//countView.style.top = Scale.Ypx(10);
		//countView.style.left = Scale.Xpx(19);
		//countView.style.width = Scale.Wpx(1920);
		countView.style.pointerEvents = "none";
		countView.style.margin = "0 auto";
		countView.style.marginLeft = Scale.Xpx(80);
		
		this.win.appendChild(countView);

		this.totalwin = CreateElement("div", {
			classes: ["total-win"],
			parentToAppend: this.win,
			style: {
				//position: "relative",
				//top: Scale.Ypx(80),
				//width: Scale.Wpx(1920),
				textAlign: "center",
				//fontSize: `${Scale.fh(5)}em`,
				fontFamily: this.resid.ScopedResourceName("font"),
				textShadow: `0px ${Scale.XYpx(10)} ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(10)} black, 0px 0px ${Scale.XYpx(20)} black`,
				color: "yellow",
				//left: Scale.Xpx(17),
				//top: Scale.Ypx(-10),
				zIndex: ZIndex.HoldAndStopBonusStats.toString(),
				display: "block",
				fontSize: Scale.fhpx(20),
				margin: "0 auto",		
			}
		});
	}

	protected BigCountAnimationRemaining(resourceManager: IReadOnlyResourceManager) {
		this.bigWinCountAnimationRemmaining = new BigWinCountAnimation(this.resid, new Size(Scale.W(80), Scale.H(80)), Scale.fh(55), this.resid.ScopedResourceName("bigwincount"));
		let countViewRemmaining = this.bigWinCountAnimationRemmaining.View();
		countViewRemmaining.style.position = "absolute";
		countViewRemmaining.style.top = Scale.Ypx(82);
		//countViewRemmaining.style.left = Scale.Xpx(200);
		//countView.style.width = Scale.Wpx(1920);
		countViewRemmaining.style.pointerEvents = "none";
		this.freegameLeftNum.appendChild(countViewRemmaining);
	}

	protected SpriteWinFrameLoaded(resourceManager: IReadOnlyResourceManager)
	{
		this.WinContainer = CreateElement("div", {
			classes: [this.resid.Scope(), "WinContainer"],
			parentToAppend: this.view,
			style: {
				position : "absolute",
				top: Scale.Ypx(-90),
				left: Scale.Ypx(3),
				width: Scale.Wpx(957),
				height: Scale.Hpx(195),
				display:"none",
				//flexDirection:"column",
				zIndex:"3",
				//overflow:"hidden",
			}
		});


		this.StickyBonusSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("StickyBonus").Add("BonusTitleStickyBonus")).sprite, canvasSize: new Size(Scale.W(450), Scale.H(170))});
		this.StickyBonusSprite.View().style.position = "absolute";
		this.StickyBonusSprite.View().style.top = Scale.Ypx(0);
		this.StickyBonusSprite.ScaleNonUniform(1.18,1.4);
		
		//this.StickyBonusSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("TitleAnim")));
		this.WinContainer.appendChild(this.StickyBonusSprite.View());

		let BackgroundContainer = CreateElement("div", {
			classes: ["background-container"],
			parentToAppend: this.WinContainer,
			style: {
				backgroundColor:"rgba(0,0,0,0.7)",
				width: Scale.Wpx(480),
				height: Scale.Hpx(159),
				position:"absolute",
				top: Scale.Ypx(14),
				left: Scale.Xpx(448),

			}
		});
		
		this.FrameSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite, canvasSize: new Size(Scale.W(520), Scale.H(195))});
		this.FrameSprite.View().style.position="absolute";
		this.FrameSprite.View().style.left = Scale.Xpx(431);
		this.FrameSprite.ScaleNonUniform(1,1.5);
		
		this.FrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		this.WinContainer.appendChild(this.FrameSprite.View());

		this.WinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(430), Scale.H(210)), Scale.fh(70),  this.resid.ScopedResourceName("bigwincount"));
		this.WinCountAnimation.View().style.position = "relative";
		this.WinCountAnimation.View().style.left = Scale.Xpx(379);
		this.WinCountAnimation.Display(service.moneyFormatter.CentsToCredit((10000)));
		this.WinCountAnimation.View().style.visibility = "visible";
		// TODO don't append into canvas?
		//this.WinContainer.appendChild(this.WinCountAnimation.View());	

	}
	protected FontHeightWinCanvas:number=Scale.fh(80);
	protected CanvaswinCountShow(resourceManager: IReadOnlyResourceManager)
	{
		this.WinCanvasShow = CreateElement("canvas", {
			classes: ["WinCanvasShow"],
			attrs: {
				width: "" + Scale.W(475),
				height: "" + Scale.H(146),
			},
			style: {
				top: Scale.Ypx(27),
				left: Scale.Xpx(451),
				position: "absolute",
				alignItems: "center",
				justifyContent: "center",
				zIndex: ""+ ZIndex.BonusWin,
				display: "block",
			}
		});

		//add gradient
		this.ctxWinCanvasShow = this.WinCanvasShow.getContext("2d");
		this.ctxWinCanvasShow.font = "bold " + this.FontHeightWinCanvas + "px " +this.resid.ScopedResourceName("bigwincount") ;

		let color:string="orangered";
		let color2:string="yellow";

		let gradient = this.ctxWinCanvasShow.createLinearGradient( this.WinCanvasShow.width /2, 
			this.WinCanvasShow.height /2 - this.fontHeight/2, 
			this.WinCanvasShow.width /2, 
			this.WinCanvasShow.height /2 + this.fontHeight/2
		);

		
		gradient.addColorStop(0,color);			
		gradient.addColorStop(0.70,color2);		
		gradient.addColorStop(1,color);		
	
		this.ctxWinCanvasShow.fillStyle = gradient;	
		this.ctxWinCanvasShow.textBaseline = "top";
		this.ctxWinCanvasShow.textAlign="center";
		this.WinContainer.appendChild(this.WinCanvasShow);
		this.SetTextCanvasWin("?",this.ctxWinCanvasShow,this.WinCanvasShow);
	}

	public SetTextCanvasWin(text:string ,ctx:CanvasRenderingContext2D,winCountcanvas:HTMLCanvasElement)
	{
		ctx.clearRect(0,0,winCountcanvas.width,winCountcanvas.height);
		ctx.strokeStyle = "black";
		ctx.lineWidth = Scale.fh(10);  
		ctx.strokeText(text,(winCountcanvas.width/2),(winCountcanvas.height/4));
		
		ctx.strokeStyle = "white";
		ctx.lineWidth =Scale.fh(10)/2;
		ctx.strokeText(text,(winCountcanvas.width/2),(winCountcanvas.height/4));
	
		ctx.fillText(text,(winCountcanvas.width/2),(winCountcanvas.height/4));
	}

	// protected ConstructReels2(resourceManager: ResourceManager): void {
	// 	super.ConstructReels2(resourceManager);
	// 	let ReelSet: HTMLElement = this.spinnableReels2.GetView();
	// 	ReelSet.querySelector(".spinnableReels2");
	// 	ReelSet.style.top = Scale.Ypx(190);
	// }

	public override Update() {
		super.Update();
		this.ContainerSprite.Update();
		this.WinValueSprite.Update();
		this.FrameSprite.Update();
		this.StickyBonusSprite.Update();
	}

	public override Start(): void {
		super.Start();
		this.bigWinCountAnimation.View().style.visibility = "visible";
		this.bigWinCountAnimation.Display(this.session.ScattersDisplayed);
		this.bigWinCountAnimationRemmaining.Display(this.session.RunsRemaining);
		this.bigWinCountAnimationRemmaining.View().style.visibility = "visible";
		this.WinValue=0;
		this.SetTextCanvasWin("?",this.ctxWinCanvasShow,this.WinCanvasShow);
	
	}

	public override Reset(): void {
		super.Reset();
		this.WinContainer.style.display = "none";
		this.freegameStats.style.display = "contents";
	}

	protected override OnFinalMessageEnd(): void {
		super.OnFinalMessageEnd();
		this.Reset();
	}


	// protected OnFeaturesBegin(): void {
	// 	super.OnFeaturesBegin();
		
	// 	this.bigWinCountAnimation.Display(this.session.ScattersDisplayed);
		
	// }

	protected override OnFeaturesBegin(): void {
		// do we have any features that triggered?
		//this.bigWinCountAnimationRemmaining.Display(3);
		this.session.RunsRemaining = this.simpleLastBonusAction.SpinsRemaining;
		
		this.session.RunsPlayed = this.simpleLastBonusAction.SpinsPlayed;
		let ScatterRandomAward = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
		this.session.ScattersDisplayed = ScatterRandomAward.ScattersTotal
		//this.currentFeature = null;
		if (ScatterRandomAward.ScattersAddedThisSpin > 0) {
			this.holdingFeature.Start(ScatterRandomAward.ScattersPositionThisSpin);
			//play sound for reset count 3 Spins Remaning
			this.audio.Play(this.resid.ScopedResourceName("TitleAnim"))
			setTimeout(() => {
				this.stateMachine.ChangeState(SpinAndHoldState.BigWin);				
			}, 500);
		}
		else {
			this.stateMachine.ChangeState(SpinAndHoldState.BigWin);
		}
		this.bigWinCountAnimationRemmaining.Display(this.session.RunsRemaining);
		
		this.bigWinCountAnimation.Display(this.session.ScattersDisplayed);
	}

	protected override OnSpinBegin(): void {
		super.OnSpinBegin();
		this.bigWinCountAnimationRemmaining.Display(this.session.RunsRemaining);

	}

	

	protected override OnCometCollectBegin(): void {
		super.OnCometCollectBegin();
		//this.WinContainer.style.display = "block";
		TweenMax.fromTo(this.WinContainer, 1, 
			{x: Scale.Xpx(-892), display:"block"},
			{x: Scale.Xpx(0), ease: Elastic.easeOut.config(1, 1)}
		);

		this.freegameStats.style.display = "none";
		
	}	

	// protected override OnCometCollectBegin(): void {
	// 	this.currentScatterCometIndex = -1;

	// 	let ScatterAwards = this.simpleEndSpinAction.find(b=>b.Phase == "End");
		
	// 	this.scatterPositions = ScatterAwards.Awards;
	// 	this.scatterPositions = this.scatterPositions.sort((a, b) => {

    //         if (a.AwardOptionPosition.Row > b.AwardOptionPosition.Row) return 1;
	// 		if (a.AwardOptionPosition.Row < b.AwardOptionPosition.Row) return -1;

	// 		if (a.AwardOptionPosition.Col > b.AwardOptionPosition.Col) return 1;
	// 		if (a.AwardOptionPosition.Col < b.AwardOptionPosition.Col) return -1;

	// 		return 0;
	// 	});

	// 	// add full award to the beginning, so it starts first
	// 	if (ScatterAwards.FullAward)
	// 	{
	// 		this.scatterPositions.unshift({
	// 			AwardOptionPosition: {
	// 				AwardOption: ScatterAwards.FullAward.AwardOption,
	// 				Col: -1,
	// 				Reel: -1,
	// 				ReelOffset: -1,
	// 				ReelPosition: -1,
	// 				Row: -1,
	// 				ColSpan : -1,
	// 				RowSpan : -1,
	// 			},
	// 			Value: ScatterAwards.FullAward.Value
	// 		});
	// 		debugger;
	// 	}

	// 	TweenMax.fromTo(this.WinContainer, 1, 
	// 				{x: Scale.Xpx(-892), display:"block"},
	// 				{x: Scale.Xpx(0), ease: Elastic.easeOut.config(1, 1)}
	// 			);
		
	// 			this.freegameStats.style.display = "none";

	// 	//commets interval 
	// 	this.nextCommetCash = this.systemContext.TimingContext().CreateTimeout("nextCommetCash", 1000, () => {
	// 		this.NextComet();
	// 	});
	// 	this.nextCommetJP4 = this.systemContext.TimingContext().CreateTimeout("nextCommetJP4", 45000, () => {
	// 		this.NextComet();
	// 		this.StopFontain(JackpotLevel.Jp4);
	// 	});
	// 	this.nextCommetJP3 = this.systemContext.TimingContext().CreateTimeout("nextCommetJP3", 31000, () => {
	// 		this.NextComet();
	// 		this.StopFontain(JackpotLevel.Jp3);
	// 	});
	// 	this.nextCommetJP1AndJP2 = this.systemContext.TimingContext().CreateTimeout("nextCommetJP1AndJP2", 6200, () => {
	// 		this.NextComet();
	// 		this.StopFontain(this.scatterPositions[this.currentScatterCometIndex]?.AwardOptionPosition.AwardOption.AwardName as JackpotLevel);
	// 	});
	// 	//show time intervals
	// 	this.JP4ShowTime = this.systemContext.TimingContext().CreateTimeout("JP4ShowTime", 500, () => this.StartShowWin(JackpotLevel.Jp4, 42000));
	// 	this.JP3ShowTime = this.systemContext.TimingContext().CreateTimeout("JP3ShowTime", 500, () => this.StartShowWin(JackpotLevel.Jp3, 29000));
	// 	this.JP2AndJP1ShowTime = this.systemContext.TimingContext().CreateTimeout("JP2AndJP1ShowTime", 500, () => this.StartShowWin(this.scatterPositions[this.currentScatterCometIndex]?.AwardOptionPosition.AwardOption.AwardName as JackpotLevel, 5500));
	// 	this.JP3ShowTime = this.systemContext.TimingContext().CreateTimeout("JP3ShowTime", 500, () => this.StartShowWin(JackpotLevel.Jp3, 29000));
		
	// 	this.NextComet();
	// }
	protected WinValue:number=0;
	protected override SendWinInfo(win: number) {
		this.FrameSprite.Start(false);
		this.StickyBonusSprite.Start(false);
		this.WinValue+=win;
		//let value:string=this.moneyFormatter.CentsToCredit(this.WinValue)
		this.SetTextCanvasWin(service.moneyFormatter.FormatCurrency(this.WinValue),this.ctxWinCanvasShow,this.WinCanvasShow);
	}

	protected override StartShowWin(jp: JackpotLevel, timerShow: number) {
      super.StartShowWin(jp, timerShow)


		// this.audio.Stop(this.resid.ScopedResourceName("background"));
	
		
		// //TweenLite.to(this.backgroundJpShowWin, 1,{ display: "flex",autoAlpha: 1 });

		// SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.Start(this.resid);

		// let currJpBackground = this.jackpotBackground.get(jp);
		// TweenLite.to(currJpBackground, 1, {display: "flex", autoAlpha: 1});

		// this.audio.Play(this.resid.ScopedResourceName(jp + "Background"));
		// this.audio.Play(this.resid.ScopedResourceName(jp + "Voice"));
		// // fadeout
		// setTimeout(() =>
		// 	TweenLite.to(currJpBackground, 1, {
		// 		autoAlpha: 0, onComplete: () => {
		// 			currJpBackground.style.display = "none";
		// 			this.audio.Stop(this.resid.ScopedResourceName(jp + "Background"));
		// 			this.audio.Stop(this.resid.ScopedResourceName(jp + "Voice"));
		// 		}
		// 	}
		// ), timerShow);

		// setTimeout(() => this.StopFontain(jp), timerShow - 500);
	}

	protected override StopFontain(jp: JackpotLevel) {
		// super.StopFontain(jp);
		// this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
		// SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.RequestStop(this.resid);
	}

	protected override async BigWinLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        // super.BigWinLoaded(resourceManager);
		// SlotGameType1Shared.Instance().jackpotFountain.forEach((fountain) => {
		// 	fountain.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		// 	fountain.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		// });
	}

	public override async AudioPrepare(resourceManager: ResourceManager): Promise<void> {
		await super.AudioPrepare(resourceManager);
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/TitleAnim" + Settings.audioFormat, this.resid.ScopedResourceName("TitleAnim")));	
	}
	
}

export class SpinAndHoldBonusFactory_1Screen extends SpinAndHoldBonusFactory {
	public CreateSpinAndHoldBonus_1Screen(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonus {
		return new SpinAndHoldBonus_1Screen(gameName, params, config);
	}
}
